




















import Vue from "vue";
import Component from "vue-class-component";

@Component({
  components: {},
})
export default class Hero extends Vue {
  private heroHeader = "RISE TO THE CALL OF DUTY";
  private heroSubheader =
    "Join the Newfound Pioneer Corps — Milsim accessible to all";
}
